(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("mapbox-tilesets", [], factory);
	else if(typeof exports === 'object')
		exports["mapbox-tilesets"] = factory();
	else
		root["mapbox-tilesets"] = factory();
})(self, function() {
return 